import axios from 'axios';

/**
 * Base API Client Configuration
 * Creates an Axios instance with default settings
 */

const apiClient = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL || 'http://localhost:5000/api',
  timeout: parseInt(import.meta.env.VITE_API_TIMEOUT || '30000'),
  headers: {
    'Content-Type': 'application/json',
  },
});

export default apiClient;
